import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { isEmpty } from 'lodash';
import { Field, propTypes as formPropTypes } from 'redux-form';
import { debouncedReduxForm } from 'sharedParts';
import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';

import { nonEmptyObject } from '../../../../../../utils/formValidators';
import propTypeBlockStyling from '../../../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class MatrixRowForm extends Component {
  static propTypes = {
    labelList: PropTypes.array.isRequired,
    block: PropTypes.object,
    option: optionPropTypes,
    inputRowField: PropTypes.func.isRequired,
    shape: PropTypes.string,
    styling: propTypeBlockStyling,
    ...formPropTypes,
  };

  rowFormValidator = this.props.required ? [nonEmptyObject()] : undefined;

  render() {
    const {
      form,
      option,
      labelList,
      inputRowField,
      shape,
      initialValues,
      styling,
      block,
    } = this.props;

    return (
      <Field
        name={option.id}
        component={inputRowField}
        format={null}
        validate={this.rowFormValidator}
        props={{
          itemListCount: labelList.length,
          hasAnswer: !isEmpty(initialValues),
          labelList,
          shape,
          form,
          option,
          styling,
          block, // passing `block` to respect getRenderedScaleIcons signature @sinslav
        }}
      />
    );
  }
}

export default compose(
  debouncedReduxForm({
    isAutoSubmit: true,
    form: 'MatrixRowForm',
    enableReinitialize: true,
  }),
)(MatrixRowForm);
